exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card-avatar{margin:0 6px;width:136px;height:164px;border-radius:10px;border:1px solid #dddfe2;background:linear-gradient(180deg,#fff 58%,#f4f4f4 0);position:relative;text-transform:capitalize}.card-avatar .name{font-size:14px;font-family:Stag Sans;font-weight:300;line-height:1.1;text-align:center;color:#3e3e3e;margin:17px 5px 10px}.card-avatar avatar-app{position:absolute;top:37%;right:25%}.card-avatar avatar-app .avatar-container{width:70px;height:70px;line-height:70px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardAvatar/cardAvatar.scss
// module id = 1625
// module chunks = 0